module.exports = __webpack_public_path__ + "img/check.6ed7be13.svg";